const GhostBumpIcon = ({ className = 'coreboundGhostBumpIcon' }) => (
  <svg
    className={className}
    viewBox="0 0 40 40"
    width="1em"
    height="1em"
    aria-hidden="true"
    focusable="false"
    style={{ overflow: 'visible', filter: 'drop-shadow(0 0 4px #a995ff99)' }}
  >
    <path
      d="M8.4 24.8c-4.1-.5-5.9-4.7-3.4-7.4"
      fill="none"
      stroke="#79e7f1"
      strokeLinecap="round"
      strokeWidth="1.8"
      opacity=".8"
    />
    <path
      d="M20 4.2c-7.7 0-13.2 6.1-13.2 14v12.4c0 1.2 1.3 1.9 2.3 1.2l4.5-3.1 4.5 3.1c.8.5 1.7.5 2.4 0l4.5-3.1 4.5 3.1c1 .7 2.3 0 2.3-1.2V18.2c0-7.9-4.1-14-11.8-14Z"
      fill="#c9c1ff"
      stroke="#eeeaff"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M11.2 13.7c1.5-4.1 4.6-6.4 8.8-6.4 4.3 0 7.1 2.4 8.3 6.7-3.4-2.6-6.1-3.1-9.1-2.1-2.5.8-5.2 1.2-8 .8Z"
      fill="#f2efff"
      opacity=".72"
    />
    <path
      d="M15.1 18.5c0 1.2-.7 2.1-1.6 2.1s-1.6-.9-1.6-2.1.7-2.1 1.6-2.1 1.6.9 1.6 2.1Zm12.9 0c0 1.2-.7 2.1-1.6 2.1s-1.6-.9-1.6-2.1.7-2.1 1.6-2.1 1.6.9 1.6 2.1Z"
      fill="#30285c"
    />
    <path
      d="M17.2 22.6c1.8 1.6 3.8 1.6 5.6 0"
      fill="none"
      stroke="#554b8a"
      strokeLinecap="round"
      strokeWidth="1.4"
    />
    <path
      d="m20 12.7 1.1 2.1 2.3.3-1.7 1.6.4 2.3-2.1-1.1-2.1 1.1.4-2.3-1.7-1.6 2.3-.3 1.1-2.1Z"
      fill="#76e7ef"
      stroke="#e1ffff"
      strokeLinejoin="round"
      strokeWidth=".55"
    />
    <path
      d="m33.2 8.1.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.8-1.4.8.3-1.6-1.2-1.1 1.6-.2.7-1.5Z"
      fill="#ffe4a0"
      opacity=".95"
    />
  </svg>
);

export default GhostBumpIcon;
